import { createMuiTheme } from '@material-ui/core'

const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        height: 48,
        fontSize: '1.125rem',
      },
    },
    MuiMenuItem: {
      root: {
        textTransform: 'uppercase',
      },
    },
    MuiSelect: {
      select: {
        borderRadius: 3,
        textTransform: 'uppercase',
      },
    },
  },
  palette: {
    primary: {
      main: '#1E2553',
      light: '#FFFFFF',
    },
    secondary: {
      main: '#099ECC',
      light: '#E1EEF6',
    },
  },
  typography: {
    fontFamily: '"Museo Sans", sans-serif',
    body1: {
      color: '#707070',
    },
  },
})

export default theme
